/*
THIS INFRAGISTICS ULTIMATE SOFTWARE LICENSE  AGREEMENT ("AGREEMENT") LOCATED HERE:
https://www.infragistics.com/legal/license/igultimate-la
https://www.infragistics.com/legal/license/igultimate-eula
GOVERNS THE LICENSING, INSTALLATION AND USE OF INFRAGISTICS SOFTWARE. BY DOWNLOADING AND/OR INSTALLING AND USING INFRAGISTICS SOFTWARE:  you are indicating that you have read and understand this Agreement, and agree to be legally bound by it on behalf of the yourself and your company.
*/
import * as tslib_1 from "tslib";
import { EventArgs, markType } from "igniteui-react-core";
/**
 * @hidden
 */
var CheckboxChangeEventArgs = /** @class */ /*@__PURE__*/ (function (_super) {
    tslib_1.__extends(CheckboxChangeEventArgs, _super);
    function CheckboxChangeEventArgs() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this._isChecked = false;
        _this._isIndeterminate = false;
        return _this;
    }
    Object.defineProperty(CheckboxChangeEventArgs.prototype, "isChecked", {
        get: function () {
            return this._isChecked;
        },
        set: function (a) {
            this._isChecked = a;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(CheckboxChangeEventArgs.prototype, "isIndeterminate", {
        get: function () {
            return this._isIndeterminate;
        },
        set: function (a) {
            this._isIndeterminate = a;
        },
        enumerable: true,
        configurable: true
    });
    CheckboxChangeEventArgs.$t = markType(CheckboxChangeEventArgs, 'CheckboxChangeEventArgs', EventArgs.$);
    return CheckboxChangeEventArgs;
}(EventArgs));
export { CheckboxChangeEventArgs };
//# sourceMappingURL=CheckboxChangeEventArgs.js.map
